export const aiLogiceditorNodeViewType = {
  CODE: 'CODE',
  NL: 'NL',
};

export const aiLogicEditorNodeViewClass = {
  [aiLogiceditorNodeViewType.CODE]: 'code',
  [aiLogiceditorNodeViewType.NL]: 'nl',
};

export const aiLogicEditorViewStateKey = {
  [aiLogiceditorNodeViewType.CODE]: 'code',
  [aiLogiceditorNodeViewType.NL]: 'SNL',
};
